import { denormalisedResponseEntities } from '../../util/data';
import { storableError } from '../../util/errors';
import { currentUserShowSuccess, fetchCurrentUserStoreProfile } from '../../ducks/user.duck';

// ================ Action types ================ //

export const CLEAR_UPDATED_FORM = 'app/ProfileSettingsPage/CLEAR_UPDATED_FORM';

export const UPLOAD_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_IMAGE_REQUEST';
export const UPLOAD_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_IMAGE_ERROR';

export const UPDATE_PROFILE_REQUEST = 'app/ProfileSettingsPage/UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'app/ProfileSettingsPage/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_ERROR = 'app/ProfileSettingsPage/UPDATE_PROFILE_ERROR';

export const SET_UPDATE_IN_PROGRESS = 'app/ProfileSettingsPage/SET_UPDATE_IN_PROGRESS';

export const UPLOAD_HEADER_IMAGE_REQUEST = 'app/ProfileSettingsPage/UPLOAD_HEADER_IMAGE_REQUEST';
export const UPLOAD_HEADER_IMAGE_SUCCESS = 'app/ProfileSettingsPage/UPLOAD_HEADER_IMAGE_SUCCESS';
export const UPLOAD_HEADER_IMAGE_ERROR = 'app/ProfileSettingsPage/UPLOAD_HEADER_IMAGE_ERROR';

const UPDATE_LISTING_REQUEST = 'app/ProfileSettingsPage/UPDATE_LISTING_REQUEST';
const UPDATE_LISTING_SUCCESS = 'app/ProfileSettingsPage/UPDATE_LISTING_SUCCESS';
const UPDATE_LISTING_ERROR = 'app/ProfileSettingsPage/UPDATE_LISTING_ERROR';

const SET_HEADER_IMAGE_FROM_LISTING = 'app/ProfileSettingsPage/SET_HEADER_IMAGE_FROM_LISTING';
// ================ Reducer ================ //

export const setHeaderImageFromListing = imageId => (
  {
    type: SET_HEADER_IMAGE_FROM_LISTING,
    payload: imageId,
  }
);

const initialState = {
  image: null,
  uploadImageError: null,
  uploadInProgress: false,
  updateInProgress: false,
  updateProfileError: null,

  // Nuevo estado para header image
  headerImage: null,
  headerUploadImageError: null,
  headerUploadInProgress: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_IMAGE_REQUEST:
      // payload.params: { id: 'tempId', file }
      return {
        ...state,
        image: { ...payload.params },
        uploadInProgress: true,
        uploadImageError: null,
      };
    case UPLOAD_IMAGE_SUCCESS: {
      // payload: { id: 'tempId', uploadedImage }
      const { id, uploadedImage } = payload;
      const { file } = state.image || {};
      const image = { id, imageId: uploadedImage.id, file, uploadedImage };
      return { ...state, image, uploadInProgress: false };
    }
    case UPLOAD_IMAGE_ERROR: {
      // eslint-disable-next-line no-console
      return { ...state, image: null, uploadInProgress: false, uploadImageError: payload.error };
    }

    // Nuevos casos para header image
    case UPLOAD_HEADER_IMAGE_REQUEST:
      return {
        ...state,
        headerImage: { ...payload.params },
        headerUploadInProgress: true,
        headerUploadImageError: null,
      };
    case UPLOAD_HEADER_IMAGE_SUCCESS: {
      const { id, uploadedImage } = payload;
      //console.log('🔄 UPLOAD_HEADER_IMAGE_SUCCESS - uploadedImage:', uploadedImage);
      const { file } = state.headerImage || {};
      const headerImage = { id, imageId: uploadedImage.id, file, uploadedImage };
      
      //console.log('Reducer - UPLOAD_HEADER_IMAGE_SUCCESS - headerImage:', headerImage);
      
      return { ...state, 
               //headerImage, 
               headerImage: uploadedImage,
               headerUploadInProgress: false };
    }
    case UPLOAD_HEADER_IMAGE_ERROR: {
      return { ...state, headerImage: null, headerUploadInProgress: false, headerUploadImageError: payload.error };
    }

    case SET_HEADER_IMAGE_FROM_LISTING:
      return {
        ...state,
        headerImage: payload ? payload/*{ imageId: payload }*/ : null,
      };

    case UPDATE_LISTING_REQUEST:
      return { 
        ...state, 
        updateListingInProgress: true, 
        updateListingError: null 
      };

    case UPDATE_LISTING_SUCCESS:
      return { 
        ...state, 
        updateListingInProgress: false 
      };

    case UPDATE_LISTING_ERROR:
      return { 
        ...state, 
        updateListingInProgress: false, 
        updateListingError: payload 
      };

    case SET_UPDATE_IN_PROGRESS:
      return {
        ...state,
        updateInProgress: payload,
      };

    case UPDATE_PROFILE_REQUEST:
      return {
        ...state,
        updateInProgress: true,
        updateProfileError: null,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        image: null,
        updateInProgress: false,
      };
    case UPDATE_PROFILE_ERROR:
      return {
        ...state,
        image: null,
        updateInProgress: false,
        updateProfileError: payload,
      };

    case CLEAR_UPDATED_FORM:
      return { ...state, updateProfileError: null, uploadImageError: null };

    default:
      return state;
  }
}

// ================ Selectors ================ //

// ================ Action creators ================ //

export const clearUpdatedForm = () => ({
  type: CLEAR_UPDATED_FORM,
});

export const setUpdateInProgress = (inProgress) => ({
  type: SET_UPDATE_IN_PROGRESS,
  payload: inProgress,
});

// SDK method: images.upload
export const uploadImageRequest = params => ({ type: UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadImageSuccess = result => ({ type: UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadImageError = error => ({
  type: UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

export const uploadHeaderImageRequest = params => ({ type: UPLOAD_HEADER_IMAGE_REQUEST, payload: { params } });
export const uploadHeaderImageSuccess = result => ({ type: UPLOAD_HEADER_IMAGE_SUCCESS, payload: result.data });
export const uploadHeaderImageError = error => ({
  type: UPLOAD_HEADER_IMAGE_ERROR,
  payload: error,
  error: true,
});

export const updateListingRequest = () => ({ type: UPDATE_LISTING_REQUEST });
export const updateListingSuccess = result => ({ type: UPDATE_LISTING_SUCCESS, payload: result });
export const updateListingError = error => ({ 
  type: UPDATE_LISTING_ERROR, 
  payload: error, 
  error: true 
});

// SDK method: sdk.currentUser.updateProfile
export const updateProfileRequest = params => ({
  type: UPDATE_PROFILE_REQUEST,
  payload: { params },
});
export const updateProfileSuccess = result => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: result.data,
});
export const updateProfileError = error => ({
  type: UPDATE_PROFILE_ERROR,
  payload: error,
  error: true,
});

// ================ Thunk ================ //

export const fetchHeaderImageFromListing = userId => {
  return (dispatch, getState, sdk) => {
    return sdk.ownListings
      .query({ 
        authorId: userId, 
        pub_listingType: 'user-profile', 
        perPage: 1,
        include: ['images'],
        "fields.image": ["variants.scaled-large", "variants.scaled-medium", "variants.scaled-small", "variants.scaled-xlarge"],
        //'fields.image': ['variants.scaled-large', 'variants.square-small', 'variants.square-small2x'],
      })
      .then(result => {
        //("result", result)
        const userProfileListing = result.data && result.data.data && result.data.data[0];
        
        if (userProfileListing && userProfileListing.attributes.publicData.headerImage) {
          const headerImageId = userProfileListing.attributes.publicData.headerImage;
          let headerImageObject = null;
          let headerImageObjectIncluded = null;

          if('included' in result.data){
            if(result.data.included.length){
              headerImageObject = result.data.included.filter(el => el.id.uuid === headerImageId);
              if(headerImageObject.length){
                headerImageObject = headerImageObject[0];
              }
            }
          }
          /*
          if('relationships' in userProfileListing){
            if('images' in userProfileListing.relationships){
              if(userProfileListing.relationships.images.data.length){
                headerImageObject = userProfileListing.relationships.images.data.filter(image => image.id.uuid === headerImageId);
                if(headerImageObject.length){
                  headerImageObjectIncluded = headerImageObject[0];

                  headerImageObject
                }
              }
            }
          }
          console.log("headerImageId: ", userProfileListing)
          */
          
          //console.log("🍁", headerImageObject)
          const headerImageObj = headerImageObject;//headerImageObjet ? headerImageObjet.id/*{ uuid: headerImageId, _sdkType: 'UUID' }*/ : null;
          //console.log("🌺", headerImageObj)
          dispatch(setHeaderImageFromListing(headerImageObj));
        } else {
          dispatch(setHeaderImageFromListing(null));
        }
      });
  };
};

// Images return imageId which we need to map with previously generated temporary id
export function uploadImage(actionPayload) {
  return (dispatch, getState, sdk) => {
    const id = actionPayload.id;
    dispatch(uploadImageRequest(actionPayload));

    const bodyParams = {
      image: actionPayload.file,
    };
    const queryParams = {
      expand: true,
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return sdk.images
      .upload(bodyParams, queryParams)
      .then(resp => {
        const uploadedImage = resp.data.data;
        //console.log("🐥", uploadedImage)
        dispatch(uploadImageSuccess({ data: { id, uploadedImage } }));
      })
      .catch(e => dispatch(uploadImageError({ id, error: storableError(e) })));
  };
}

// Nueva función para header image upload (completamente independiente)
export function uploadHeaderImage(actionPayload) {
 
  return (dispatch, getState, sdk) => {
    const id = actionPayload.id;
    dispatch(uploadHeaderImageRequest(actionPayload));

    const bodyParams = {
      image: actionPayload.file,
    };
    const queryParams = {
      expand: true,
      //'fields.image': ['variants.square-small', 'variants.square-small2x'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium', 
        'variants.scaled-large',
        'variants.scaled-xlarge'
      ],
    };

    return sdk.images
      .upload(bodyParams, queryParams)
      .then(resp => {
        const uploadedImage = resp.data.data;
        //console.log("🐝", uploadedImage)
        dispatch(uploadHeaderImageSuccess({ data: { id, uploadedImage } }));
      })
      .catch(e => dispatch(uploadHeaderImageError({ id, error: storableError(e) })));
  };
}

export const updateProfile = actionPayload => {
  return (dispatch, getState, sdk) => {
    dispatch(updateProfileRequest());

    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    //console.log("🐳", actionPayload, queryParams);

    return sdk.currentUser
      .updateProfile(actionPayload, queryParams)
      .then(response => {
        dispatch(updateProfileSuccess(response));

        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];
        //console.log("🌹🌹🌹🌹🌹", currentUser)
        // Update current user in state.user.currentUser through user.duck.js
        dispatch(currentUserShowSuccess(currentUser));

        if (currentUser.attributes.profile.publicData.userType === 'tienda-oficial') {
          dispatch(fetchCurrentUserStoreProfile());
        }
      })
      .catch(e => dispatch(updateProfileError(storableError(e))));
  };
};

export const updateUserProfileListing = (userId, headerImageId) => {
  //alert("xxx")
  //console.log("🐭🐭🐭", userId, headerImageId)
  return (dispatch, getState, sdk) => {
    dispatch(updateListingRequest());
    
    
    // 1. Buscar el listing tipo user-profile del usuario
    return sdk.ownListings
      .query({ authorId: userId, pub_listingType: 'user-profile', perPage: 1 })
      .then(result => {
        const userProfileListing = result.data && result.data.data && result.data.data[0];
        if (!userProfileListing) {
          throw new Error('No se encontró el listing user-profile del usuario');
        }
        //console.log("☘️", userProfileListing)
        //console.log("🐠", userId, headerImageId)
        //return null;

        // 2. Actualizar el publicData del listing
        return sdk.ownListings
          .update(
            {
              id: userProfileListing.id,
              images: [headerImageId],
              publicData: {
                ...userProfileListing.attributes.publicData,
                headerImage: headerImageId,
              },
              //title: listing.attributes.title,
              //description: listing.attributes.description,
            },
            {
              expand: true,
              include: ['images'],
            }
          );
        }
      )
      .then(response => {
        dispatch(updateListingSuccess(response));
        dispatch(fetchHeaderImageFromListing(userId));
      })
      .catch(e => dispatch(updateListingError(storableError(e))));
  };
};
